export default "__VITE_ASSET__88cdc093__"